"use strict";

function _toConsumableArray(e) {
    return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread()
}

function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _unsupportedIterableToArray(e, t) {
    if (e) {
        if ("string" == typeof e) return _arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0
    }
}

function _iterableToArray(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
}

function _arrayWithoutHoles(e) {
    if (Array.isArray(e)) return _arrayLikeToArray(e)
}

function _arrayLikeToArray(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
    return a
}


if (document.querySelector(".footer")) {
    var block = document.querySelectorAll(".footer__column-head");
    _toConsumableArray(block).forEach(function (t) {
        t.addEventListener("click", function () {
            _toConsumableArray(block).forEach(function (e) {
                e !== t && e.classList.remove("is-active")
            }), t.classList.toggle("is-active")
            $('.footer__top ul').removeAttr('style');
            if (t.classList.contains('is-active')) {
                if ($(t).next().find('li').length) {
                    $(t).next().css({height: $(t).next().find('li').length * $(t).next().find('li').height() + 20});
                }
            } else {
                if ($(t).next()) $(t).next().removeAttr('style');
            }
        })
    });
    var resHandler = function() {
        if ($(window).innerWidth() <= 992) {
            document.querySelector(".footer__column-head").classList.add("is-active")
            let tmpli = $(".footer__column-head:first").next().find('li');
            $(".footer__column-head:first").next().css({height: tmpli.length * tmpli.height() + 20});
        }
    };
    window.addEventListener("resize", resHandler)
} else if (document.querySelector(".partner-form")) {
    var resHandler = function () {
        if ($(document).width() <= 484) {
            location.pathname.match("/en") ? document.querySelector(".lang-switcher-dark__btn").innerHTML = "EN" : location.pathname.match("/ua") ? document.querySelector(".lang-switcher-dark__btn").innerHTML = "UA" : document.querySelector(".lang-switcher-dark__btn").innerHTML = "RU";
        }
    };
    window.addEventListener("resize", resHandler);
}

$(document).ready(function() {
    if (resHandler) resHandler();
    $('.lang-switcher-dark').css({opacity: 1});
		$('body').on('click', '.lang-switcher-dark__option', function(){
			if (!$(this).hasClass('is-active')) {
				location.href = $(this).attr('data-href');
			}
		});
	$('body').on('click', '.lang-switcher-dark, .lang-switcher-dark__btn', function(e){
		e.preventDefault();
		e.stopPropagation();
		if ($(e.target).parents().add(e.target).filter('.lang-switcher-dark__select').length) return true;
		let langSwitcher = $('.lang-switcher-dark');
		langSwitcher.toggleClass('is-active');
	});
});